export default "__VITE_ASSET__ByaBr2yy__"